import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createGovReportingFacilityMutationAtom = createMutationAtomFactory(
  'settings.govReportingFacilityCreate',
  (params: {
    governmentReportingConfigurationId: string;
    facilityId: string;
    reportingFacilityId?: string;
    mlid?: string;
  }) => ({
    complianceGovernmentReportingFacilityCreate: {
      __args: {
        input: {
          governmentReportingConfigurationId:
            params.governmentReportingConfigurationId,
          facilityId: params.facilityId,
          reportingFacilityId: params.reportingFacilityId,
          mlid: params.mlid,
        },
      },
      id: true,
    },
  }),
);
